import logger from '../services/logger';
import pubSub from '../services/pubsub';
import template from '../services/template';
/**
 * A module is a class which is part of a host platform. A host platform usually refers to a framework/UI library
 * such as React, Angular, Ember, VueJS, etc. It could also mean a certain type of environment, such as the Vanilla
 * DOM (essentially no framework), or shadow DOM, or within the context of a custom element. It could even be something
 * like a server rendering html, or even a hybrid platform like ionic. Basically, it's an entity which is part of a
 * runtime that uses web technologies for user interfaces.
 */
export default class Module {
    /**
     * Subclasses which extend Module should provide an attachTo() method that takes a root element and
     * returns an instantiated module with its root set to that element.
     */
    static attachTo(root) {
        return new Module(root);
    }
    constructor(root) {
        this.root_ = root;
        this.name_ = 'module';
    }
    /**
     * Bootstrap codes that must be called explicitly.
     * Will be automatically called by `autoInit`
     */
    start() {
        // start
    }
    /**
     * Subclasses may implement this method to release any resources / deregister any listeners they have
     * attached. An example of this might be deregistering a resize event from the window object.
     */
    destroy() {
        // TODO: remove all subscribers
    }
    /**
     * Event listening using PubSub (so no need to import `PubSub` explicitly)
     */
    subscribe(topic, handler) {
        return pubSub.subscribe(topic, handler);
    }
    /**
     * Ont-time event listening using PubSub
     */
    subscribeOnce(topic, handler) {
        pubSub.subscribeOnce(topic, handler);
    }
    /**
     * Event dispatching using PubSub
     */
    publish(topic, data) {
        pubSub.publish(topic, data);
    }
    /**
     * Log things (so no need to import `Logger` explicitly)
     */
    log(msg, raw = false, error = false) {
        logger.log(this.name_, msg, raw, error ? console.error : undefined);
    }
    /**
     * Log error
     */
    logError(msg, raw = false) {
        this.log(msg, raw, true);
    }
    /**
     * Log unknown error
     */
    logUnknownError(error, publishToSentry = false, raw = false) {
        logger.logUnknownError(error, this.name_, raw);
        if (publishToSentry) {
            this.publish('sentry:log', { error: error, module: this.name_ });
        }
    }
    /**
     * Renders a module's own template
     * @deprecated
     */
    render(templateName, data) {
        return template.render(this.name_, templateName, data);
    }
}
